import type { ReactNode } from 'react';

export type SwitchProps = Readonly<{
  testID?: string;
  value: boolean;
  leftLabel?: ReactNode;
  size?: StateTypes;
  rightLabel?: ReactNode;
  showIcons?: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  palette?: SwitchPalette;
}>;

export const SwitchSizeStates = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

export enum SwitchState {
  Disabled = 0,
  Off = -1,
  On = 1,
}

export type SwitchPalette = 'kale' | 'spinach' | 'success';

export type StateTypes = Required<keyof typeof SwitchSizeStates>;
